import { Avatar, Paper, Stack, Typography } from '@mui/material';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { FromHeart, Statoscope, SocialHelp, EmploymentIcon } from 'Images';
import { useContext } from 'react';
import { SpecialEntitlementState } from './SpecialEntitlementState';
import { HiddenAccessibilityText } from 'Components/HiddenAccessibilityText';

interface IEntitlementCategory {
  category: string;
  automatic: boolean;
  oneTime: boolean;
}

export const EntitlementCategory = ({
  category,
  automatic,
  oneTime,
}: IEntitlementCategory) => {
  const isDesktop = useIsDesktop();
  const { categories } = useContext(EntitlementsContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);

  const filterIcons = [FromHeart, Statoscope, SocialHelp, EmploymentIcon];

  const categoriesIcons = [];
  for (let i = 0; i < categories?.length; i++)
    categoriesIcons.push({
      id: categories[i].id,
      image: filterIcons[i],
      name: categories[i].name,
    });

  const entitlementCategory = categoriesIcons.find((categoryIcon) => {
    return categoryIcon.id === parseInt(category);
  });

  const shortenedName: { [index: string]: string } = {
    [dictionary.filters.employment]: dictionary.filtersShortName.employment,
    [dictionary.filters.medical]: dictionary.filtersShortName.medical,
    [dictionary.filters.medicalFix]: dictionary.filtersShortName.medical,
    [dictionary.filters.social]: dictionary.filtersShortName.social,
    [dictionary.filters.welfare]: dictionary.filtersShortName.welfare,
  };

  return (
    <Stack
      direction='row'
      gap='16px'
      width='fit-content'
      height={isDesktop ? '48px' : '40px'}
    >
      {parseInt(category) >= 0 && parseInt(category) <= categories?.length && (
        <Paper
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            boxShadow: 'none',
            border: '1px solid',
            borderColor: 'primary.shade_200',
            borderRadius: '6px',
            padding: '8px',
            gap: '6px',
            width: 'fit-content',
          }}
        >
          <HiddenAccessibilityText
            text={dictionary.entitlements.belongToCategory}
            ariaLive='polite'
          />
          <Avatar
            alt=''
            src={entitlementCategory?.image}
            sx={{
              width: isDesktop ? '32px' : '26px',
              height: isDesktop ? '32px' : '26px',
            }}
          />
          <Typography variant={'body6'} whiteSpace='nowrap'>
            {categories ? shortenedName[entitlementCategory?.name ?? ''] : null}
          </Typography>
        </Paper>
      )}
      {automatic && (
        <SpecialEntitlementState text={dictionary.entitlements.automatic} />
      )}
      {oneTime && (
        <SpecialEntitlementState text={dictionary.entitlements.singleUse} />
      )}
    </Stack>
  );
};
